import { render, staticRenderFns } from "./AddObject.vue?vue&type=template&id=44760534"
import script from "./AddObject.js?vue&type=script&lang=js&external"
export * from "./AddObject.js?vue&type=script&lang=js&external"
import style0 from "./AddObject.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports